import { useLocation } from 'react-router-dom';
import { CustomizationSidebar } from './components/customization-sidebar';

export default function CustomizationLayout({ children }: { children: React.ReactNode }) {
  const pathname = useLocation().pathname;

  // Determine active page from pathname
  const getActivePage = () => {
    if (pathname.includes('/presets')) return 'presets';
    if (pathname.includes('/themes')) return 'themes';
    return 'presets'; // default
  };

  const activePage = getActivePage();

  const handlePageSelect = (page: string) => {
    // Navigation is handled by Link components in the sidebar
  };

  return (
    <div className="flex h-full w-full">
      <CustomizationSidebar activePage={activePage} onPageSelect={handlePageSelect} />
      <div className="flex-1 overflow-auto">
        {children}
      </div>
    </div>
  );
}
